import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core';
import TextBoxWithTooltip from '../textBoxWithTooltip';

const useStyles = makeStyles(({ palette: { primary } }) => ({
  root: {
    display: 'block',
    textDecoration: 'none',
    maxWidth: '100%',
  },
  text: {
    color: primary.blue1,
    cursor: 'pointer',
  },
}));

const TextLink = ({
  className = undefined,
  textClass = undefined,
  to,
  text,
  variant = 'body1',
  ...rest
}) => {
  const classes = useStyles();

  return (
    <Link className={classNames(classes.root, className)} to={to}>
      <TextBoxWithTooltip
        className={classNames(classes.text, textClass)}
        variant={variant}
        text={text}
        isClickable
        {...rest}
      />
    </Link>
  );
};

TextLink.propTypes = {
  className: PropTypes.string,
  textClass: PropTypes.string,
  to: PropTypes.string.isRequired,
  variant: PropTypes.string,
  text: PropTypes.string.isRequired,
};

export default TextLink;
